export enum CustomerState {
    UNSPECIFIED = 'unspecified',
    OPPORTUNITY = 'opportunity',
    LEAD = 'lead',
    CONTACTED = 'contacted',
    ACTIVE = 'active',
    INACTIVE = 'inactive',
}
